// extracted by mini-css-extract-plugin
export default {"menu":"TeacherMenu_menu__EWpZL","logo":"TeacherMenu_logo__NI71l","navGroup":"TeacherMenu_navGroup__zUS4l","active":"TeacherMenu_active__FyQTQ"};